<div class="Footer_bottom">
<ng-container *ngFor="let item of mainHead">
  <section class="page-hero-section d-flex flex-column align-items-center justify-content-center" [ngStyle]="(item && item.banner) ? {'background-image': 'url(' + item.banner + ')'} : {}">
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="text text-center">
                    <h1 class="page-hero-title">{{ item?.title || 'Impact Stories' }}</h1>
                    <p class="page-hero-subtitle text-center" [innerHTML]="item?.subTitle || ''"></p>
                </div>
            </div>
        </div>
    </div>
  </section>
</ng-container>
<section class="storiesCard" *ngIf="hideImpactData">
    <div class="container">
      <div class="row" >
        <div class="col-12">
          <h3 class="color-44 mb-4" style="margin-bottom: 30px;">Impact Stories</h3>
      </div>
      <ng-container *ngIf="impactData.length">
        <ng-container *ngFor="let items of impactData.slice(0,6); let i = index">
          <div class="col-md-4" style="margin-bottom: 35px;">
    <div class="card-bg h-100">
      <div class="card h-100 card-hover border-0 shadow-sm">
        <div class="position-relative main-img">

          <img [src]="items?.banner" class="card-img-top h-100 rounded-0 img-fluid card-img" alt="...">
        </div>
        <div class="card-body" style="background-color: #00625F;">
          <h6 class="text-white">{{items?.title}}</h6>
          <p class="card-text text-white" [innerHTML]="items?.description | truncatePipe : 150"></p>

        </div>
        <div class="text-center card-footer" style="background-color: #00625F;">
          <button class="btn read-btn mb-3 text-white rounded-pill" style="background-color: #47d985; border: 1px solid #47d985;" routerLink="/related-stories" [queryParams]="{ id: items?.id, prevRoute: prevRoute}">Read More</button>
        </div>
       </div>
    </div>
          </div>
          </ng-container>
          <ng-container *ngIf="isLoadMore">
            <ng-container *ngFor="let items of impactData.slice(6, impactData.length); let i = index">
              <div class="col-md-4" style="margin-bottom: 35px;">
        <div class="card-bg h-100">
          <div class="card h-100 card-hover border-0 shadow-sm">
            <div class="position-relative main-img">

              <img [src]="items?.banner" class="card-img-top h-100 rounded-0 img-fluid card-img" alt="...">
            </div>
            <div class="card-body" style="background-color: #00625F;">
              <h6 class="text-white">{{items?.title}}</h6>
              <p class="card-text text-white" [innerHTML]="items?.description | truncatePipe : 150"></p>

            </div>
            <div class="text-center card-footer" style="background-color: #00625F;">
              <button class="btn read-btn mb-3 text-white rounded-pill" style="background-color: #47d985; border: 1px solid #47d985;" routerLink="/related-stories" [queryParams]="{ id: items?.id, prevRoute: prevRoute}">Read More</button>
            </div>
           </div>
        </div>
              </div>
              </ng-container>
          </ng-container>
          <span class="loadmoreTab mb-3" (click)="isLoadMore = !isLoadMore" *ngIf="impactData.length > 4"><u>{{!isLoadMore ? 'Show More..' : 'Show Less'}}</u></span>
      </ng-container>
      </div>
    </div>
</section>
</div>